import { ProductConfig } from "../types/requestTypes";
import { IInitialValues } from "./InitialCalcConfig";
import { t } from "../utils/intl";
import { getFormatCurrencyValue } from "../helpers/customHooks/getFormatCurrencyValue";

interface IValidationResult {
  isInvalid: boolean;
  invalidMessage: string;
}

const paymentsNotEmpty = (config: ProductConfig, form: IInitialValues) => {
  return {
    isInvalid: !form.payments,
    invalidMessage: t("form.Empty")
  };
};

const durationInYearsNotEmpty = (config: ProductConfig, form: IInitialValues) => {
  return {
    isInvalid: !form.durationInYears,
    invalidMessage: t("form.Empty")
  };
};

const premiumPerFreqNotEmpty = (config: ProductConfig, form: IInitialValues) => {
  return {
    isInvalid: !form.premiumPerFreq,
    invalidMessage: t("form.Empty")
  };
};

const paymentsCheckLimits = (config: ProductConfig, form: IInitialValues) => {
  let result: IValidationResult = {
    isInvalid: false,
    invalidMessage: ""
  };

  if (!form.durationInYears || !form.payments) {
    return result;
  }

  const paymentLimits = config.validations.paymentsLimits.find(
    el => el.durationInYears === form.durationInYears
  );
  if (!paymentLimits) return result;

  const minResult = {
    isInvalid: +form.payments < paymentLimits.min,
    invalidMessage: t("form.minPayments", { min: paymentLimits.min })
  };

  const maxResult = {
    isInvalid: +form.payments > paymentLimits.max,
    invalidMessage: t("form.maxPayments", { max: paymentLimits.max })
  };

  if (minResult.isInvalid) return minResult;
  if (maxResult.isInvalid) return maxResult;

  return result;
};

const premiumPerFreqCheckLimits = (config: ProductConfig, form: IInitialValues) => {
  let result: IValidationResult = {
    isInvalid: false,
    invalidMessage: ""
  };

  if (!form.premiumPerFreq || !form.durationInYears || !form.payments) {
    return result;
  }

  const premiumperfreqlimit = config.validations.premiumperfreqlimits.find(
    el => el.frequencycode === form.frequencyCode
  );

  if (!premiumperfreqlimit) return result;

  const minResult = {
    isInvalid: +form.premiumPerFreq < premiumperfreqlimit.min,
    invalidMessage: t("form.minPremiumPerFreq", {
      min: getFormatCurrencyValue(premiumperfreqlimit.min)
    })
  };

  const maxResult = {
    isInvalid: +form.premiumPerFreq > +premiumperfreqlimit.max,
    invalidMessage: t("form.maxPremiumPerFreq", {
      max: getFormatCurrencyValue(premiumperfreqlimit.max)
    })
  };

  if (minResult.isInvalid) return minResult;
  if (maxResult.isInvalid) return maxResult;

  return result;
};

const premiumPerFreqCheckMaxSum = (config: ProductConfig, form: IInitialValues) => {
  let result: IValidationResult = {
    isInvalid: false,
    invalidMessage: ""
  };

  if (!form.premiumPerFreq || !form.durationInYears || !form.payments) {
    return result;
  }
  const sumOfPremiums = form.payments * +form.premiumPerFreq;

  const sumOfPremiumsLimit = config.validations.sumOfPremiumsLimits.find(
    el => el.payments === form.payments && el.durationInYears === form.durationInYears
  );

  if (!sumOfPremiumsLimit) return result;

  const maxSumResult = {
    isInvalid: sumOfPremiums > sumOfPremiumsLimit.max,
    invalidMessage: t("form.maxSumPremiumPerFreq", {
      max: sumOfPremiumsLimit.max,
      current: sumOfPremiums
    })
  };

  if (maxSumResult.isInvalid) return maxSumResult;

  return result;
};

export const basicValidations = [
  {
    id: "payments",
    validations: [paymentsNotEmpty, paymentsCheckLimits]
  },
  {
    id: "durationInYears",
    validations: [durationInYearsNotEmpty]
  },
  {
    id: "premiumPerFreq",
    validations: [premiumPerFreqNotEmpty, premiumPerFreqCheckLimits, premiumPerFreqCheckMaxSum]
  }
];
